const Types = {
    EXPAND: "Expand",
    COLLAPSE: "Collapse",

    CHANGE_LANG: "Change Language",
    
    SET_CHECKBOX: "SET_CHECKBOX",

    SET_IMAGE_SRC: "Set Image Src",

    SET_DESIGN_FEATURE: "Set Design Feature",

    ADD_BUILDING: "Add Building",
    DELETE_BUILDING: "Delete Building",
    SET_CURRENT_BUILDING: "Set Current Building",

    SET_CURRENT_REPORT_BUILDING: "Set Current Report Building",

    ADD_FACADE: "Add Facade",
    DELETE_FACADE: "Delete Facade",
    SET_CURRENT_FACADE: "Set Current Facade",
}

export default Types;


// WEBPACK FOOTER //
// ./src/modules/actionTypes.js